import { lazy } from "react";
import { Navigate } from "react-router-dom";

const CarePlansPage = lazy(() => import("./pages/CarePlansPage"));
const CarePlanCreationPage = lazy(() => import("./pages/CarePlanCreationPage"));
const CarePlansCard = lazy(() => import("./components/cards/CarePlansCard"));

export const carePlansRoutes = [
  { path: "/care-plan", element: <CarePlansPage /> },
  { path: "/Careplan", element: <Navigate to="/care-plan" replace /> },
  { path: "/create-care-plan/:patientId", element: <CarePlanCreationPage /> },
  { path: "/care-plans/:patientId", element: <CarePlansCard /> },
  { path: "/IACarePlanPage", element: <Navigate to="/care-plan" replace /> },
];
